<template>
    <span>
        <slot v-if="can" />
    </span>
</template>

<script>
export default {
    name: "RoleManager",
    data() {
        return {}
    },
    mounted() {
    
    },
    computed:{
        can(){
            return this.$app.roles.indexOf('manager') >= 0 || this.$app.roles.indexOf('owner') >= 0
        }
    }
}
</script>

<style scoped lang="less">

</style>